// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1381":"97250490b1083060","2613":"42e2ff5a5398f28a","4511":"8940905d343764b8","9748":"9146017b28d4deb9"}[chunkId] + ".js";
};